import http from '../../Utils/http';
const loginData = () => {
  let access_token = localStorage.getItem('access_token')
    ? localStorage.getItem('access_token')
    : null;
  let refreshToken = localStorage.getItem('refreshToken')
    ? localStorage.getItem('refreshToken')
    : null;
  let userInfo = localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null;
  let data = {};
  if (access_token && refreshToken) {
    data.tokens = {
      access_token: access_token,
      refreshToken: refreshToken,
    };
  }
  if (userInfo) {
    data.userInfo = userInfo;
  }
  return data;
};

const Login = {
  name: 'user',
  state: {
    loading: false,
    data: loginData().userInfo,
    tokens: loginData().tokens,
    error: '',
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
  },
  reducers: {
    loginRequested(state) {
      localStorage.clear();
      return {
        ...state,
        loading: true,
        error: '',
      };
    },
    createUserRequested(state){
      return {
        ...state,
        loading: true,
        error: '',
        message:''
      };
    },

    loginReceived(state, payload) {
      if(payload.userInfo.active === false){
        return {
          ...state,
          tokens: '',
          data: '',
          loading: false,
          error: 'Your account is temporarily disabled. Please contact at support@savvydisplays.com.',
        };
      }
      else{
      let data = {
        ...state,
        tokens: payload.tokens,
        data: payload.userInfo,
        loading: false,
        error: '',
      };
      if (payload.userInfo.roles) {
        data.permissions = payload.userInfo.roles.permissions;
      }
      return data;
    }
    },
    createNewUserReceived(state){
      return {
        ...state,
        loading:false,
        message:'User Created Successfully',
        error:'',
      }
    },
    createNewUserRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        message:'',
        loading:false,
      };
    },
    loginRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
      };
    },

    closeSnackbarRed(state) {
      return {
        ...state,
        error: null,
      };
    },

    logoutReducer(state) {
      return {
        ...state,
        tokens: '',
        data: '',
        loading: false,
        error: '',
      };
    },

    toggleTermsAndConditions(state, payload) {
      return {
        ...state,
        data: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async login(data) {
      try {
        this.loginRequested();
        const response = await http.post(`savvy/users/login`, data);
        console.log('response', response);
        this.loginReceived(response.data.data);

        //local storge logic
        const { tokens, userInfo } = response.data.data;

        localStorage.setItem('access_token', tokens.access_token);
        localStorage.setItem('refreshToken', tokens.refresh_token);
        localStorage.setItem('last_login', tokens.last_login);
        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      } catch (err) {
        this.loginRequestFailed(err.response.data.message || err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid email or password',
            open: true,
          },
        });
      }
    },

    async createNewUser(data) {
      try {
        this.createUserRequested();
        const response = await http.post(`/savvy/users/`, data);
        if(response?.data?.data){
        this.createNewUserReceived();
        }
      } catch (err) {
        this.createNewUserRequestFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },

    async AgreeToTerms(data, state) {
      const id = state?.user?.data?.id;
      try {
        await http.put(`savvy/users/agreeToTermsandConditions/${id}`, data);

        this.toggleTermsAndConditions({
          ...state?.user?.data,
          agreed_on_tearms: true,
        });
      } catch (err) {
        this.loginRequestFailed(err.response.data.message || err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid email or password',
            open: true,
          },
        });
      }
    },

    async closeSnackbar() {
      this.closeSnackbarRed();
    },

    async logout(id) {
      await http.delete(`savvy/users/logout/${id}`);
      localStorage.clear();
      this.logoutReducer();
    },
  }),
};

export default Login;
